import { minigridTypes } from "./minigrid.types";

export const setIsLoadingListMinigridAction = (isLoadingListMinigrid : boolean) => ({
    type: minigridTypes.IS_LOADING_LIST_MINIGRID,
    payload: isLoadingListMinigrid
})

export const setQuerySearchAction = (querySearch : string | null) => ({
    type: minigridTypes.SET_QUERY_SEARCH,
    payload: querySearch
})